export default __webpack_public_path__ + "static/media/a9.9e02ba27.jpg";